import { FC, useState } from 'react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { CirclePlus, MapPin, VectorPolygon } from 'lucide-react'

interface AddGeometryProps {
    setDrawMode: (mode: 'Marker' | 'Polygon' | null) => void
}

export const AddGeometry: FC<AddGeometryProps> = ({ setDrawMode }) => {
    const [color, setColor] = useState('var(--color-mm-gray)')
    const [isOpen, setIsOpen] = useState(false)

    const handleSetDrawMode = (mode: 'Marker' | 'Polygon' | null) => {
        setDrawMode(mode)
    }

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
                <CirclePlus
                    color={color}
                    size={18}
                    className={'cursor-pointer transition-all'}
                    onMouseEnter={() => setColor('var(--color-mm-gray2)')}
                    onMouseLeave={() => setColor('var(--color-mm-gray)')}
                    onClick={() => setIsOpen(true)}
                />
            </PopoverTrigger>
            <PopoverContent className={'z-2005 w-fit p-1'}>
                <div className="flex flex-row gap-1">
                    <MapPin
                        className={'cursor-pointer rounded-md p-2 hover:bg-mm-bg hover:ring ring-mm-border h-8 w-8'}
                        onClick={() => handleSetDrawMode('Marker')}
                        color={'var(--color-mm-gray)'}
                        role={'button'}
                    />
                    <VectorPolygon
                        className={'cursor-pointer rounded-md p-2 hover:bg-mm-bg hover:ring ring-mm-border h-8 w-8'}
                        onClick={() => handleSetDrawMode('Polygon')}
                        color={'var(--color-mm-gray)'}
                        role={'button'}
                    />
                </div>
            </PopoverContent>
        </Popover>
    )
}
